<template>
  <el-dialog :title="$t('productSeckill.confirmOperation')" :visible.sync="dialogVisible" width="30%"
    @close="handleClose">
    <div style="text-align:center">
      <p>{{ $t('productSeckill.confirmDeleteSeckill') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('productSeckill.cancel') }}
      </el-button>
      <el-button type="primary" @click="deleteProductSeckill">
        {{ $t('productSeckill.confirmDelete') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteProductSeckill } from '@/api/group/productSeckillApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteProductSeckill',
  data() {
    return {
      dialogVisible: false,
      deleteProductSeckillInfo: {
        killId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteProductSeckillInfo.killId = row.killId
    },
    handleClose() {
      this.deleteProductSeckillInfo = {
        killId: ''
      }
    },
    async deleteProductSeckill() {
      try {
        this.deleteProductSeckillInfo.shopId = getShopId()
        await deleteProductSeckill(this.deleteProductSeckillInfo)
        this.$message.success(this.$t('common.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>